<template>
  <div :class="{ 'sidebar-position-new': true }">
    <SidebarTopRightOrientation>
      <div class="sidebar-top-right-orientation__right">
        <button
          @click="closeSidebarPositionNew"
          class="sidebar-top-right-orientation__button"
        >
          <div class="sidebar-top-right-orientation__button__text">Sluit</div>
          <svg class="sidebar-top-right-orientation__button__icon" svg-inline="" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" transform="rotate(-45 12 12)" d="M11 4h2v16h-2z"/><path fill="#101010" mask="url(#b)" transform="rotate(45 12 12)" d="M11 4h2v16h-2z"/></g></svg>
        </button>
      </div>
    </SidebarTopRightOrientation>

    <div class="sidebar-position-new__bottom">
      <div class="sidebar-position-new__map-top">
        <SidebarTitleBar>
          <div
            class="sidebar-title-bar__icon-container"
            @click="openSidebarMunicipalitiesIndex"
            :style="{ fill: appAsset ? appAsset.color_primary : '#101010' }"
          >
            <svg svg-inline="" class="sidebar-title-bar__icon-container__icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#101010" mask="url(#b)" d="M16 4.462L14.603 3 6 12l8.603 9L16 19.538 8.795 12z"/></g></svg>
          </div>

          <div class="sidebar-title-bar__inner">
            <div class="sidebar-title-bar__inner__left">
              <div
                class="sidebar-title-bar__inner__left__title"
                :style="{ color: appAsset ? appAsset.color_primary : null }"
              >
                {{ activeMunicipality.name }}
              </div>
              <div class="sidebar-title-bar__inner__left__subtitle">
                Bepaal je locatie
              </div>
            </div>
            <div class="sidebar-title-bar__inner__right">
              <div
                class="sidebar-title-bar__inner__right__text-right"
                @click="createPosition"
                :style="{ color: appAsset ? appAsset.color_primary : null }"
              >
                Volgende
              </div>
            </div>
          </div>
        </SidebarTitleBar>

        <GpsSearch>
          <input
            class="gps-search__input-field"
            type="text"
            placeholder="Zoek adres of versleep de pin"
            ref="autocomplete"
          />
          <svg svg-inline="" class="gps-search__search-icon" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" fill="#101010" mask="url(#b)"/></g></svg>
          <div class="gps-search__input-small">
            Of klik op het GPS-icoontje om je eigen locatie te gebruiken
          </div>
          <template v-if="gpsLoading">
            <svg svg-inline="" class="gps-search__spinner-icon" focusable="false" role="presentation" aria-hidden="true" data-prefix="fas" data-icon="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="currentColor" d="M304 48c0 26.51-21.49 48-48 48s-48-21.49-48-48 21.49-48 48-48 48 21.49 48 48zm-48 368c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zm208-208c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.49-48-48-48zM96 256c0-26.51-21.49-48-48-48S0 229.49 0 256s21.49 48 48 48 48-21.49 48-48zm12.922 99.078c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.491-48-48-48zm294.156 0c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48c0-26.509-21.49-48-48-48zM108.922 60.922c-26.51 0-48 21.49-48 48s21.49 48 48 48 48-21.49 48-48-21.491-48-48-48z"/></svg>
          </template>
          <template v-else>
            <svg svg-inline="" class="gps-search__location-icon" @click="updatePosition" focusable="false" role="presentation" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><defs><path id="a" d="M0 0h24v24H0z"/></defs><g fill="none" fill-rule="evenodd"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path d="M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3A8.994 8.994 0 0013 3.06V1h-2v2.06A8.994 8.994 0 003.06 11H1v2h2.06A8.994 8.994 0 0011 20.94V23h2v-2.06A8.994 8.994 0 0020.94 13H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z" fill="#101010" mask="url(#b)"/></g></svg>
          </template>
        </GpsSearch>
      </div>
      <div
        class="sidebar-position-new__map"
        ref="sidebarPositionNewMap"
        id="sidebarPositionNewMap"
      ></div>
      <div class="sidebar-position-new__map-bottom">
        <div class="sidebar-position-new__map-bottom__title">
          {{ address }}
        </div>
        <div class="sidebar-position-new__map-bottom__subtitle">
          {{ activeMunicipality.name }}
        </div>

        <label
          for="radius-select"
          class="sidebar-position-new__radius-select-label"
          >Toon meldingen in een straal van {{ radius }} meter:</label
        >
        <vue-slider
          class="sidebar-position-new__radius-select"
          id="radius-select"
          :min="100"
          :max="1000"
          v-model="radius"
          @change="updateRadius"
          tooltip="none"
        />
      </div>
    </div>

    <template v-if="modalNonParticipantTwo">
      <ModalNonParticipantTwo
        :selectedNonParticipant="selectedNonParticipantTwo"
      />
    </template>

    <template v-if="active">
      <portal to="page-shadow">
        <PageShadow />
      </portal>
    </template>
  </div>
</template>

<script>
import PrivateApi from "@/services/PrivateApi.js";
import PageShadow from "@/components/PageShadow.vue";
import SidebarTitleBar from "@/components/SidebarTitleBar.vue";
import GpsSearch from "@/components/GpsSearch.vue";
import ModalNonParticipantTwo from "@/components/Home/ModalNonParticipantTwo.vue";
import gmapsInit from "@/utils/gmaps";
import SidebarTopRightOrientation from "@/components/SidebarTopRightOrientation.vue";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  components: {
    SidebarTitleBar,
    PageShadow,
    SidebarTopRightOrientation,
    GpsSearch,
    VueSlider,
    ModalNonParticipantTwo
  },
  async mounted() {
    try {
      let self = this;

      if (this.activeView) {
        let mapId = this.$refs.sidebarPositionNewMap;

        gmapsInit().then(function(google) {
          self.google = google;
          var map = new google.maps.Map(mapId, {
            disableDefaultUI: true
          });

          self.map = map;
          var lat, lng;

          if (self.gpsLatitude) {
            lat = self.gpsLatitude;
          }

          if (self.gpsLongitude) {
            lng = self.gpsLongitude;
          }

          if (!lat || !lng) {
            var placesService = new self.google.maps.places.PlacesService(map);
            var request = {
              query: self.activeMunicipality.name,
              fields: ["name", "geometry"]
            };

            placesService.findPlaceFromQuery(request, function(
              results,
              status
            ) {
              if (status === google.maps.places.PlacesServiceStatus.OK) {
                lat = results[0].geometry.location.lat();
                lng = results[0].geometry.location.lng();
                self.setLocationRequirements(map, lat, lng);
              }
            });
          } else {
            self.setLocationRequirements(map, lat, lng);
          }
        });
      }
    } catch (error) {
      console.error(error);
    }
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "theme-color",
          content: this.appAsset ? this.appAsset.color_primary : "#6DCC00",
          vmid: "theme-color"
        }
      ]
    };
  },
  data() {
    let activeMunicipality = this.$store.state.ui.activeMunicipality;
    return {
      radius: 250,
      municipalityName: activeMunicipality.name,
      address: null,
      gpsLoading: false
    };
  },
  computed: {
    appAsset() {
      return this.activeMunicipality ? this.activeMunicipality.app_asset : null;
    },
    gpsLatitude() {
      return this.$store.state.ui.gpsLatitude;
    },
    gpsLongitude() {
      return this.$store.state.ui.gpsLongitude;
    },
    activeMunicipality() {
      return this.$store.state.ui.activeMunicipality;
    },
    activeView() {
      return this.$store.state.ui.sidebarPositionNew;
    },
    modalNonParticipantTwo() {
      return this.$store.state.ui.modalNonParticipantTwo;
    },
    selectedNonParticipantTwo() {
      return this.$store.state.ui.selectedNonParticipantTwo;
    },
    active() {
      return !this.modalNonParticipantTwo;
    }
  },
  methods: {
    setLocationRequirements(map, lat, lng) {
      let self = this;

      var initPosition = {
        lat: lat,
        lng: lng
      };

      map.setCenter(initPosition);
      map.setZoom(14);

      var autocomplete = new google.maps.places.Autocomplete(
        self.$refs.autocomplete,
        {
          types: ["geocode"],
          componentRestrictions: { country: "NL" }
        }
      );

      self.autocomplete = autocomplete;

      autocomplete.addListener("place_changed", () => {
        let place = self.autocomplete.getPlace();
        let latitude = place.geometry.location.lat();
        let longitude = place.geometry.location.lng();

        self.address = place.formatted_address;

        var position = { lat: latitude, lng: longitude };
        self.$store.commit("setGpsLatitude", latitude);
        self.$store.commit("setGpsLongitude", longitude);

        self.setAddressFromPosition(position);
        self.updatePositionAndMapDetails(position);
        self.setActiveMunicipalityFromLocation(latitude, longitude);
      });

      var marker = new self.google.maps.Marker({
        map: map,
        position: initPosition,
        icon: {
          url: "/ic_location@2x.png",
          anchor: new google.maps.Point(16, 16),
          scaledSize: new google.maps.Size(32, 32)
        },
        draggable: true
      });

      var circle = new self.google.maps.Circle({
        map: map,
        strokeWeight: 0,
        fillColor: self.appAsset ? self.appAsset.color_primary : "#6DCC00",
        fillOpacity: 0.33,
        center: initPosition,
        radius: self.radius
      });

      var geocoder = new self.google.maps.Geocoder();

      marker.addListener("dragend", function(event) {
        var latitude = event.latLng.lat();
        var longitude = event.latLng.lng();
        var position = { lat: latitude, lng: longitude };
        self.setAddressFromPosition(position);
        self.$store.commit("setGpsLatitude", latitude);
        self.$store.commit("setGpsLongitude", longitude);
        self.map.setCenter(position);
        marker.setPosition(position);
        circle.setCenter(position);
        self.setActiveMunicipalityFromLocation(latitude, longitude);
      });

      self.marker = marker;
      self.circle = circle;
      self.geocoder = geocoder;
      self.setAddressFromPosition(initPosition);
    },
    closeSidebarPositionNew() {
      if (this.$route.matched.filter(x => x.path == "/gemeentes/:id").length) {
        this.$router.push("/");
      }
      this.$store.commit("closeSidebarPositionNew");
    },
    openSidebarMunicipalitiesIndex() {
      this.$store.commit("openSidebarMunicipalitiesIndex");
      this.closeSidebarPositionNew();
    },
    createPosition() {
      let self = this;

      let data = {
        latitude: this.gpsLatitude,
        longitude: this.gpsLongitude,
        radius: this.radius,
        address: this.address
      };

      PrivateApi()
        .post("positions", data)
        .then(function(position) {
          var positions = self.$store.state.data.loadedPositions;
          positions.data.push(position.data);
          self.$store.commit("setUpdatedPositionCount", true);
          self.$store.commit("setLoadedPositions", positions);

          self.$store.commit("setHomePosition", position.data);
          self.$store.commit("openSidebarPositionSaved");
          self.closeSidebarPositionNew();
        });
    },
    updatePosition() {
      let self = this;
      this.gpsLoading = true;

      function success(position) {
        self.gpsLoading = false;
        var latitude = position.coords.latitude;
        var longitude = position.coords.longitude;
        self.$store.commit("setGpsLatitude", latitude);
        self.$store.commit("setGpsLongitude", longitude);
        self.setActiveMunicipalityFromLocation(latitude, longitude);
        position = { lat: latitude, lng: longitude };
        self.setAddressFromPosition(position);
        self.updatePositionAndMapDetails(position);
      }
      function error() {
        self.gpsLoading = false;
        alert("Verleen alstublieft toestemming om uw locatie te delen");
      }

      navigator.geolocation.getCurrentPosition(success, error);
    },
    updateRadius() {
      this.circle.setRadius(parseInt(this.radius));
      this.map.fitBounds(this.circle.getBounds(), 0);
    },
    updatePositionAndMapDetails(position) {
      this.map.setCenter(position);
      this.marker.setPosition(position);
      this.marker.setTitle("Geselecteerde locatie");
      this.circle.setCenter(position);
      this.map.setZoom(14);
    },
    setActiveMunicipalityFromLocation(latitude, longitude) {
      let self = this;

      PrivateApi()
        .get(
          `gemeentes?search_by_location[latitude]=${latitude}&search_by_location[longitude]=${longitude}`
        )
        .then(function(gemeentes) {
          let municipality = gemeentes.data[0];
          self.$store.commit("setActiveMunicipality", municipality);
          if (self.$route.params.id != municipality.id) {
            self.$router.push(`/gemeentes/${municipality.id}`);
          }
          if (
            gemeentes.data[0].payment_status != "paid" &&
            !gemeentes.data[0].payment_status != "trial"
          ) {
            self.$store.commit("openModalNonParticipantTwo", gemeentes.data[0]);
          } else {
            self.$store.commit("closeModalNonParticipantTwo");
          }
        });
    },
    setAddressFromPosition(position) {
      let self = this;
      this.geocoder.geocode({ location: position }, function(results, status) {
        if (status === "OK") {
          if (results[0]) {
            let address_components = results[0].address_components;
            let street = address_components.find(x => x.types.includes("route"))
              ? address_components.find(x => x.types.includes("route"))
                  .short_name
              : "";
            let street_number = address_components.find(x =>
              x.types.includes("street_number")
            )
              ? " " +
                address_components.find(x => x.types.includes("street_number"))
                  .short_name
              : "";
            let city = address_components.find(x =>
              x.types.includes("political")
            ).short_name;
            self.address = `${street}${street_number}, ${city}`;
          } else {
            window.alert("No results found");
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.sidebar-position-new {
  position: fixed;
  width: 100%;
  max-width: 414px;
  background: $color-gray-2;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  z-index: 3000;

  &__bottom {
    flex: 1;
    overflow-y: auto;
  }
  #sidebarPositionNewMap {
    width: 100%;
    height: 300px;
  }

  &__map-top {
    padding: $spacing-3;
    background: #fff;
  }

  &__map-bottom {
    padding: $spacing-3;
    background: #fff;

    &__title {
      @extend %text-title-1;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    &__subtitle {
      @extend %text-large-light;
      width: 100%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-top: 5px;
    }
  }

  &__radius-select-label {
    display: inline-block;
    margin-top: $spacing-6;
    @extend %text-small;
  }
}

@media (min-width: 768px) {
  .sidebar-position-new {
    &__map-top {
      padding: $spacing-4;
    }
    &__map-bottom {
      padding: $spacing-4;
    }
  }
}
</style>
